import React from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Bar } from "react-chartjs-2";

// Register Chart.js components + datalabels plugin
ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
  Title,
  ChartDataLabels
);

const JcDetailedJobCardTat = ({ data }) => {
  if (!data || data.length === 0) return <p>No data available</p>;

  const labels = data.map((item) => item.year);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Closed Within TAT",
        data: data.map((item) => item.confirmedPercentage),
        backgroundColor: "#4CAF50",
        borderRadius: 6,
        borderWidth: 1,
        barThickness: data.length === 1 ? 80 : undefined,
      },
      {
        label: "Closed Outside TAT",
        data: data.map((item) => item.nonConfirmedPercentage),
        backgroundColor: "#F44336",
        borderRadius: 6,
        borderWidth: 1,
        barThickness: data.length === 1 ? 80 : undefined,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false }, // Hide built-in legend
      title: {
        display: false,
        text: "Job Closure TAT (%)",
        font: { size: 16, weight: "bold" },
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.dataset.label}: ${context.parsed.y}%`,
        },
      },
      datalabels: {
        display: true,
        color: "white",
        font: { weight: "bold", size: 12 },
        formatter: (value) => `${value}%`,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: { display: false },
        title: { display: true, text: "Year", font: { weight: "bold", size: 13 } },
        ticks: { font: { weight: "bold", size: 12 } },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        max: 100,
        display: false,
      },
    },
  };

  const chartWidth =
    data.length === 1 ? 300 : data.length === 2 ? 400 : Math.max(data.length * 120, 600);

  return (
    <div className="w-full bg-white p-4 rounded-xl shadow">
      {/* Custom sticky legend */}
      <div className="flex space-x-4 mb-2 font-bold text-sm">
        <div className="flex items-center space-x-1">
          <div className="w-4 h-4 bg-green-500 rounded"></div>
          <span>Closed Within TAT</span>
        </div>
        <div className="flex items-center space-x-1">
          <div className="w-4 h-4 bg-red-500 rounded"></div>
          <span>Closed Outside TAT</span>
        </div>
      </div>

      {/* Scrollable chart */}
      <div className="overflow-x-auto">
        <div
          style={{
            width: chartWidth,
            height: 400,
          }}
        >
          <Bar data={chartData} options={options} />
        </div>
      </div>
    </div>
  );
};

export default JcDetailedJobCardTat;
